/**
 * Matriz de acceso por rol.
 * Regla: cada rol NO administrador tiene jurisdicción sobre UN solo módulo.
 * La psicóloga administradora (Dra. Mariela Chiessa · is_admin=true) puede ver los 5.
 */

// module_id -> list of allowed roles (además de is_admin siempre)
// Aula es transversal: docente/sombra/familia acceden pero cada quien ve SOLO los cursos con track para su rol
export const MODULE_ACCESS = {
  circulo: ["familia"],
  aula: ["docente", "sombra", "familia"],
  sintonia: ["psicologa"],
  brujula: ["escuela"],
  sello: ["sombra"],
};

// Tools institucionales (solo admin/psicologa)
export const ADMIN_ONLY_ROUTES = ["tablero", "boletin", "evidencia", "historial"];

/**
 * Devuelve true si el usuario puede entrar al módulo indicado.
 * - Admin (Mariela) → todo.
 * - Otros roles → solo su módulo asignado (o herramientas admin si is_admin=true).
 */
export function canAccessModule(user, moduleId) {
  if (!user) return false;
  if (user.is_admin) return true;
  if (ADMIN_ONLY_ROUTES.includes(moduleId)) return false;
  const roles = MODULE_ACCESS[moduleId];
  if (!roles) return true; // billing y otros no restringidos
  return roles.includes(user.role);
}

/**
 * Devuelve la lista de módulos visibles para el usuario en la home.
 */
export function visibleModules(user, allModules) {
  if (!user) return [];
  if (user.is_admin) return allModules;
  return allModules.filter((m) => canAccessModule(user, m.id));
}
